module.exports = __webpack_public_path__ + "img/sold_sign.cd94d600.svg";